export type ColorName =
	| "Beige"
	| "Black"
	| "Blue"
	| "Green"
	| "Grey"
	| "Orange"
	| "Pink"
	| "Purple"
	| "Red"
	| "Silver"
	| "Transparent"
	| "Turquoise"
	| "White"
	| "Yellow"
	| "Dyed";

export type ColorEntry = {
	name: ColorName;
	hex: string;
	dyed?: boolean;
	transparent?: boolean;
};

export const COLORS: ColorEntry[] = [
	{ name: "Beige", hex: "#d4b896" },
	{ name: "Black", hex: "#1a202c" },
	{ name: "Blue", hex: "#3182ce" },
	{ name: "Green", hex: "#3a9e3a" },
	{ name: "Grey", hex: "#718096" },
	{ name: "Orange", hex: "#ed8936" },
	{ name: "Pink", hex: "#fbb6ce" },
	{ name: "Purple", hex: "#805ad5" },
	{ name: "Red", hex: "#e53e3e" },
	{ name: "Silver", hex: "#a8a9ad" },
	{ name: "Transparent", hex: "transparent", transparent: true },
	{ name: "Turquoise", hex: "#00897b" },
	{ name: "White", hex: "#f7fafc" },
	{ name: "Yellow", hex: "#ecc94b" },
	{ name: "Dyed", hex: "dyed", dyed: true },
];

export const COLOR_HEX: Record<string, string> = Object.fromEntries(
	COLORS.filter((c) => !c.dyed && !c.transparent).map((c) => [c.name, c.hex]),
);

export const DYED_GRADIENT =
	"conic-gradient(red, orange, yellow, green, blue, violet, red)";

export const TRANSPARENT_PATTERN =
	"repeating-conic-gradient(#d4d4d4 0% 25%, #ffffff 0% 50%) 0 0 / 8px 8px";

export type ConditionValue = "9" | "8" | "7" | "6" | "5" | "1-3";

export type ConditionTier = { value: ConditionValue; label: string };

export const CONDITION_TIERS: ConditionTier[] = [
	{ value: "9", label: "Like New" },
	{ value: "8", label: "Excellent" },
	{ value: "7", label: "Good" },
	{ value: "6", label: "Fair" },
	{ value: "5", label: "Worn" },
	{ value: "1-3", label: "Beat" },
];

// Slider order: worst → best (Beat at index 0, Like New at last index)
export const CONDITION_SLIDER: ConditionTier[] = [...CONDITION_TIERS].reverse();

export const CONDITION_LABEL: Record<string, string> = Object.fromEntries(
	CONDITION_TIERS.map((t) => [t.value, t.label]),
);

export const DISC_CLASSES = [
	{ value: "putter" as const, label: "Putter" },
	{ value: "midrange" as const, label: "Midrange" },
	{ value: "fairway-driver" as const, label: "Fairway driver" },
	{ value: "distance-driver" as const, label: "Distance driver" },
];

export const DISC_CLASS_LABEL: Record<string, string> = Object.fromEntries(
	DISC_CLASSES.map((c) => [c.value, c.label]),
);

export const SHIPS_TO_OPTIONS = [
	{ value: "pickup-only" as const, label: "Pickup only" },
	{ value: "domestic" as const, label: "Domestic" },
	{ value: "international" as const, label: "International" },
];

export const SHIPS_TO_LABEL: Record<string, string> = Object.fromEntries(
	SHIPS_TO_OPTIONS.map((o) => [o.value, o.label]),
);
